(function () {
  var root = document.querySelector('[data-showroom-booking]');
  var configNode = document.getElementById('showroom-booking-config');

  if (!root || !configNode) {
    return;
  }

  var config = {};

  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (error) {
    config = {};
  }

  config.endpoint = String(config.endpoint || '').trim();

  var state = {
    currentMonth: startOfMonth(new Date()),
    selectedDate: null,
    selectedTime: null,
    availability: {},
    loading: false
  };

  var monthLabel = root.querySelector('[data-booking-month-label]');
  var calendarGrid = root.querySelector('[data-booking-calendar-grid]');
  var statusNode = root.querySelector('[data-booking-status]');
  var slotsNode = root.querySelector('[data-booking-slots]');
  var selectedDateNode = root.querySelector('[data-booking-selected-date]');
  var timezoneNode = root.querySelector('[data-booking-timezone]');
  var form = root.querySelector('[data-booking-form]');
  var prevButton = root.querySelector('[data-booking-prev-month]');
  var nextButton = root.querySelector('[data-booking-next-month]');

  var today = stripTime(new Date());
  var minDate = addHours(new Date(), Number(config.minNoticeHours || 24));
  var maxDate = addDays(today, Number(config.bookingWindowDays || 60));
  var monthFormatter = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' });
  var dateFormatter = new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  });

  if (timezoneNode && config.timezone) {
    timezoneNode.textContent = config.timezone;
  }

  prevButton.addEventListener('click', function () {
    state.currentMonth = addMonths(state.currentMonth, -1);
    state.selectedDate = null;
    state.selectedTime = null;
    render();
    loadAvailabilityForCurrentMonth();
  });

  nextButton.addEventListener('click', function () {
    state.currentMonth = addMonths(state.currentMonth, 1);
    state.selectedDate = null;
    state.selectedTime = null;
    render();
    loadAvailabilityForCurrentMonth();
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    submitBooking();
  });

  render();
  loadAvailabilityForCurrentMonth();

  function render() {
    renderMonth();
    renderSlots();
    updateForm();
    updateMonthControls();
  }

  function renderMonth() {
    var year = state.currentMonth.getFullYear();
    var month = state.currentMonth.getMonth();
    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var firstDay = new Date(year, month, 1).getDay();
    var cells = [];

    monthLabel.textContent = monthFormatter.format(state.currentMonth);
    calendarGrid.innerHTML = '';

    for (var offset = 0; offset < firstDay; offset += 1) {
      cells.push(createCalendarSpacer());
    }

    for (var day = 1; day <= daysInMonth; day += 1) {
      cells.push(createCalendarDay(new Date(year, month, day)));
    }

    cells.forEach(function (cell) {
      calendarGrid.appendChild(cell);
    });
  }

  function createCalendarSpacer() {
    var spacer = document.createElement('span');
    spacer.className = 'showroom-booking-day showroom-booking-day-empty';
    spacer.setAttribute('aria-hidden', 'true');
    return spacer;
  }

  function createCalendarDay(date) {
    var button = document.createElement('button');
    var dateKey = toDateKey(date);
    var slots = state.availability[dateKey] || [];
    var isPast = stripTime(date) < today;
    var isBeforeNotice = stripTime(date) < stripTime(minDate);
    var isBeyondWindow = stripTime(date) > maxDate;
    var hasSlots = slots.length > 0;
    var isSelected = state.selectedDate === dateKey;

    button.type = 'button';
    button.className = 'showroom-booking-day';
    button.textContent = String(date.getDate());
    button.dataset.date = dateKey;
    button.disabled = isPast || isBeforeNotice || isBeyondWindow || !hasSlots || state.loading;
    button.setAttribute('aria-label', dateFormatter.format(date));

    if (hasSlots) {
      button.classList.add('is-available');
    }

    if (isSelected) {
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
    }

    button.addEventListener('click', function () {
      state.selectedDate = dateKey;
      state.selectedTime = null;
      render();
    });

    return button;
  }

  function renderSlots() {
    var slots = state.selectedDate ? state.availability[state.selectedDate] || [] : [];
    slotsNode.innerHTML = '';

    if (!state.selectedDate) {
      selectedDateNode.textContent = 'Select an available date';
      slotsNode.innerHTML = '<p class="showroom-booking-empty">Available times will appear here.</p>';
      return;
    }

    selectedDateNode.textContent = dateFormatter.format(dateFromKey(state.selectedDate));

    if (!slots.length) {
      slotsNode.innerHTML = '<p class="showroom-booking-empty">No times are available for this date.</p>';
      return;
    }

    slots.forEach(function (slot) {
      var button = document.createElement('button');
      var time = typeof slot === 'string' ? slot : slot.time;

      button.type = 'button';
      button.className = 'showroom-booking-slot';
      button.textContent = formatTimeLabel(time);
      button.dataset.time = time;

      if (state.selectedTime === time) {
        button.classList.add('is-selected');
      }

      button.addEventListener('click', function () {
        state.selectedTime = time;
        render();
      });

      slotsNode.appendChild(button);
    });
  }

  function updateForm() {
    var hasSelection = Boolean(state.selectedDate && state.selectedTime);

    form.hidden = !hasSelection;

    if (hasSelection) {
      form.elements.date.value = state.selectedDate;
      form.elements.time.value = state.selectedTime;
    }
  }

  function updateMonthControls() {
    var previousMonth = addMonths(state.currentMonth, -1);
    var nextMonth = addMonths(state.currentMonth, 1);

    prevButton.disabled = endOfMonth(previousMonth) < today || state.loading;
    nextButton.disabled = startOfMonth(nextMonth) > maxDate || state.loading;
  }

  function setStatus(message, type) {
    statusNode.textContent = message || '';
    statusNode.dataset.status = type || '';
  }

  function loadAvailabilityForCurrentMonth(preserveStatus) {
    if (!config.endpoint) {
      state.availability = {};
      setStatus('Availability is ready to connect. Add the booking API endpoint in Theme settings.', 'setup');
      render();
      return;
    }

    var start = toDateKey(state.currentMonth);
    var end = toDateKey(endOfMonth(state.currentMonth));
    var url;

    try {
      url = new URL(config.endpoint, window.location.origin);
    } catch (error) {
      state.availability = {};
      setStatus('The booking API endpoint is not a valid URL.', 'error');
      render();
      return;
    }

    url.searchParams.set('action', 'availability');
    url.searchParams.set('start', start);
    url.searchParams.set('end', end);
    url.searchParams.set('timezone', config.timezone || 'America/El_Salvador');
    url.searchParams.set('duration', String(config.duration || 30));

    state.loading = true;
    if (!preserveStatus) {
      setStatus('Loading availability...', 'loading');
    }
    render();

    fetch(url.toString(), { method: 'GET' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Availability request failed');
        }

        return response.json();
      })
      .then(function (payload) {
        state.availability = normalizeAvailability(payload);
        state.loading = false;
        if (!preserveStatus) {
          setStatus('', '');
        }
        render();
      })
      .catch(function () {
        state.availability = {};
        state.loading = false;
        if (!preserveStatus) {
          setStatus('We could not load availability. Please try again in a moment.', 'error');
        }
        render();
      });
  }

  function submitBooking() {
    if (!config.endpoint || !state.selectedDate || !state.selectedTime) {
      setStatus('Please select an available date and time.', 'error');
      return;
    }

    var submitButton = form.querySelector('button[type="submit"]');
    var formData = new FormData(form);
    var payload = {
      action: 'book',
      date: state.selectedDate,
      time: state.selectedTime,
      timezone: config.timezone || 'America/El_Salvador',
      duration: Number(config.duration || 30),
      location: config.location || '',
      customer: {
        name: String(formData.get('name') || '').trim(),
        email: String(formData.get('email') || '').trim(),
        phone: String(formData.get('phone') || '').trim()
      },
      notes: String(formData.get('notes') || '').trim()
    };

    submitButton.disabled = true;
    setStatus('Booking your appointment...', 'loading');

    fetch(config.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Booking request failed');
        }

        return response.json();
      })
      .then(function (payload) {
        if (payload && payload.ok === false) {
          throw new Error(payload.message || 'Booking request failed');
        }

        form.reset();
        form.hidden = true;
        state.selectedTime = null;
        setStatus('Your showroom visit is confirmed. Please check your email for details.', 'success');
        loadAvailabilityForCurrentMonth(true);
      })
      .catch(function () {
        setStatus('We could not confirm this appointment. Please choose another time or email info@souf.shop.', 'error');
      })
      .finally(function () {
        submitButton.disabled = false;
      });
  }

  function normalizeAvailability(payload) {
    var days = {};

    if (!payload) {
      return days;
    }

    if (payload.days) {
      Object.keys(payload.days).forEach(function (dateKey) {
        days[dateKey] = payload.days[dateKey].map(normalizeSlot).filter(Boolean).map(function (slot) {
          return typeof slot === 'string' ? slot : slot.time;
        });
      });
    }

    if (Array.isArray(payload.availableSlots)) {
      payload.availableSlots.forEach(function (slot) {
        var normalized = normalizeSlot(slot);

        if (normalized && normalized.date && normalized.time) {
          if (!days[normalized.date]) {
            days[normalized.date] = [];
          }

          days[normalized.date].push(normalized.time);
        }
      });
    }

    Object.keys(days).forEach(function (dateKey) {
      days[dateKey] = unique(days[dateKey]).sort();
    });

    return days;
  }

  function normalizeSlot(slot) {
    if (typeof slot === 'string') {
      if (/^\d{2}:\d{2}$/.test(slot)) {
        return slot;
      }

      return slotFromIso(slot);
    }

    if (slot && slot.time) {
      return slot.time;
    }

    if (slot && slot.start) {
      return slotFromIso(slot.start);
    }

    return null;
  }

  function slotFromIso(value) {
    var date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return null;
    }

    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: config.timezone || 'America/El_Salvador',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(date);

    var lookup = parts.reduce(function (accumulator, part) {
      accumulator[part.type] = part.value;
      return accumulator;
    }, {});

    return {
      date: lookup.year + '-' + lookup.month + '-' + lookup.day,
      time: lookup.hour + ':' + lookup.minute
    };
  }

  function formatTimeLabel(time) {
    var parts = String(time).split(':');
    var hours = Number(parts[0]);
    var minutes = Number(parts[1] || 0);
    var suffix = hours >= 12 ? 'PM' : 'AM';
    var displayHours = hours % 12 || 12;

    return displayHours + ':' + String(minutes).padStart(2, '0') + ' ' + suffix;
  }

  function toDateKey(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');

    return year + '-' + month + '-' + day;
  }

  function dateFromKey(value) {
    var parts = value.split('-').map(Number);
    return new Date(parts[0], parts[1] - 1, parts[2]);
  }

  function startOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  function endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  function addMonths(date, amount) {
    return new Date(date.getFullYear(), date.getMonth() + amount, 1);
  }

  function addDays(date, amount) {
    var next = new Date(date);
    next.setDate(next.getDate() + amount);
    return next;
  }

  function addHours(date, amount) {
    var next = new Date(date);
    next.setHours(next.getHours() + amount);
    return next;
  }

  function stripTime(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function unique(values) {
    return values.filter(function (value, index) {
      return values.indexOf(value) === index;
    });
  }
})();
